interface LogoProps {
  className?: string
  size?: number
}

export function Logo({ className = '', size = 40 }: LogoProps) {
  return (
    <img 
      src="https://res.cloudinary.com/dz92jtvzt/image/upload/v1774278701/logo-no-bg_vbyfqb.png"
      alt="JE Pro Group"
      style={{ height: `${size}px`, width: 'auto' }}
      className={className}
    />
  )
}